import React from "react";
import TopNavigation from '../navigation/TopNavigation'
import logo from '../../img/logo_text_white.png'
import Cover from "../3js/Cover";
// import { Button } from 'semantic-ui-react'
import Icon, { FacebookOutlined, LinkedinOutlined, YoutubeOutlined, ArrowUpOutlined, GithubOutlined } from '@ant-design/icons';
import { BackTop, Divider, Button, Row, Col, Card } from 'antd';
import ImageApp from "../3js/Intro";

// import { Cover } from '../../cover/index1'


function HomePage(props) {

  const handleSignUp = () => {
    props.history.push("/signup")
  }
  const handleLogin = () => {
    props.history.push("/login")
  }
  const handleGoMainApp = () => {
    props.history.push("/main")
  }
  const handleGoAddin = () => {
    props.history.push("/getkey")
  }
  return (
    <>
      {/* <TopNavigation {...props} /> */}
      <main>
        <div className='intro-content-main'>
          {/* <Cover position={false} /> */}
          <Cover />
          <div className={'intro-content-main-inner'}>
            <a className='intro-button-go-app' href="https://drive.google.com/file/d/1f6x1lTOEEDxJtKJ_1JO65lVg-GwmEJM_/view?usp=sharing" target={'_blank'}>
              <span>Download CV</span>
              <div className='liquid'></div>
            </a>

          </div>
        </div>
      </main>
      {/* <div className='intro-content partner'>
        <div className='intro-text'>
          Trusted by
        </div>
        <div className='intro-brand'>
          <a href="https://onecadvn.com/" target="_blank">
            <img style={{ maxWidth: '100px', maxHeight: '90px' }}
            // src={oneCad}
            />
          </a>
        </div>

      </div> */}

      <div className='intro-content feature' id='intro-content-feature'>
        <div className='intro-feature'>
          <div className='intro-feature-text' >
            <h1>
              Hello, my friend
            </h1>
            <div style={{ marginBottom: 20 }}>
              <span>
                My name is Lan. I am <span style={{ color: 'lightblue', fontWeight: 'bold' }}> BIM Developer  </span> and <span style={{ color: 'lightgreen', fontWeight: 'bold' }}> Web Developer</span>
                . I have a passion for technology and want to apply it in multiple industries. I am working on many projects around the world.
              </span>
              <br />
              <br />
              <span>
                Have a good time when you look at my portfolio
              </span>
              <br />
              <span > Thank you!</span>

            </div>

          </div>

          <ImageApp />

        </div>
      </div>





      {/* 
      <div className='intro-content pricing' id='intro-content-pricing' >
        <div className='intro-pricing'>
          <Row gutter={8}>
            <Col span={8}>
              <Card
                className='intro-card'
                bodyStyle={{
                  padding: 0
                }}
                bordered={false}
                hoverable
                title={
                  <div className='intro-card-title'>
                    <h1> FREE  </h1>
                    <div className='pricing-free'>
                      $
                      <span>
                        0
                      </span>
                      .00
                    </div>
                    <div className='intro-card-footer'>forever</div>
                  </div>
                }
              >
                <>
                  <div className='intro-card-content-free'>
                    <span>
                      Coming Soon
                    </span>
                  </div>
                  <Divider style={{ margin: 0 }} />
                  <div style={{ padding: "10px 0", textAlign: 'center' }}>
                    <Button color='orange' onClick={props.isConfirmed ? handleGoMainApp : handleSignUp}>
                      Try
                    </Button>
                  </div>
                </>

              </Card>
            </Col>
            <Col span={8}>
              <Card
                hoverable
                className='intro-card-recommend'
                bodyStyle={{
                  padding: 0
                }}
                bordered={false}
                title={
                  <div className='intro-card-title'>
                    <h1> INDIVIDUAL  </h1>
                    <div className='pricing'>
                      $
                      <span>
                        9
                      </span>
                      .99
                    </div>
                    <div className='intro-card-footer'>month</div>
                  </div>
                }
              >
                <>
                  <div className='intro-card-content'>
                    <span>
                      Coming Soon
                    </span>
                  </div>
                  <Divider style={{ margin: 0 }} />
                  <div style={{ padding: "10px 0", textAlign: 'center' }}>
                    <Button className='intro-button-price' onClick={props.isConfirmed ? handleGoMainApp : handleSignUp}>
                      Try
                    </Button>
                  </div>
                </>
              </Card>
            </Col>
            <Col span={8}>
              <Card
                hoverable
                className='intro-card'
                bodyStyle={{
                  padding: 0
                }}
                bordered={false}
                title={
                  <div className='intro-card-title'>
                    <h1> TEAM  </h1>
                    <div className='pricing'>
                      $
                      <span>
                        19
                      </span>
                      .99
                    </div>
                    <div className='intro-card-footer'>month</div>
                  </div>
                }
              >
                <>
                  <div className='intro-card-content'>
                    <span>
                      Coming Soon
                    </span>
                  </div>
                  <Divider style={{ margin: 0 }} />
                  <div style={{ padding: "10px 0", textAlign: 'center' }}>
                    <Button className='intro-button-price' onClick={props.isConfirmed ? handleGoMainApp : handleSignUp}>
                      Try
                    </Button>
                  </div>
                </>
              </Card>
            </Col>
          </Row>

        </div>
      </div> */}
      <footer>
        <div className='intro-content footer' id='intro-footer'>
          <div>
            <div className="intro-contact">
              Contact:{' '}
              <br />
              <a>
                baoquylan@gmail.com
              </a>
            </div>

            <img style={{ maxWidth: '100px', maxHeight: '90px' }}
              src={logo}
            />
          </div>

          <br />
          <div className="intro-icons-list">
            <a href="https://www.facebook.com/baoquylan" target="_blank" >
              <FacebookOutlined size={40} style={{ width: 40 , height:40}} />
            </a>
            <a href="https://www.linkedin.com/in/lan-bao-802219143/" >
              <LinkedinOutlined style={{ width: 40 }} />
            </a>
            <a href="https://www.youtube.com/channel/UCONUAZwafHiGzZs6rvfMykA" target="_blank" >
              <YoutubeOutlined style={{ width: 40 }} />
            </a>
            <a href="https://github.com/baoquylan" target="_blank" >
              <GithubOutlined style={{ width: 40 }} />
            </a>
          </div>

          <h3>
            © 2022 Copyright, Inc. All rights reserved.
          </h3>
        </div>

      </footer>
      <BackTop>
        <div className="intro-back-top">
          <ArrowUpOutlined />
        </div>
      </BackTop>
    </>
  )
}



export default HomePage